export const PLAYER_STATES = {
  LOADED: 'LOADED',
  CAPTURED: 'CAPTURED',
};

export default PLAYER_STATES;
